module.exports = __webpack_public_path__ + "static/carpoolchella-cta-3-5f8f77f4df73e4a6176cbed6d7a12695.jpg";